import { Link } from 'react-router-dom'

import { NotLivePage, useNotLivePage } from '@/app/notLive'
import { Card, EmptyState, LoadingBlock, formatCurrency } from '@/design'
import { useFilterSearch } from '@/lib/useGlobalFilters'

import { useListingTemplates, useMoney } from './hooks'
import './listings.css'

/** Saved field presets: a quick starting point for a new listing's prize details (pivot doc §6 Stage 3). */
export function TemplatesPage() {
  const notLive = useNotLivePage('listingTemplates')
  const templates = useListingTemplates()
  const money = useMoney()
  const search = useFilterSearch()
  const rows = templates.data?.data ?? []

  if (notLive) return <NotLivePage />

  return (
    <Card title="Templates" subtitle="Saved prize presets to start a new listing from." busy={templates.isFetching}>
      {templates.isPending ? <LoadingBlock rows={3} /> : null}
      {templates.isError ? <EmptyState variant="outage" compact description="Templates could not be loaded." /> : null}
      {templates.data && rows.length === 0 ? (
        <EmptyState variant="no-data" compact title="No templates yet" description="Save a listing's prize details as a template to reuse them." />
      ) : null}
      {rows.length > 0 ? (
        <ul className="lst-templates">
          {rows.map((template) => (
            <li key={template.id} className="lst-template-card">
              <div>
                <h3>{template.name}</h3>
                <p className="lst-muted">{template.description}</p>
                <dl className="lst-template-card__facts">
                  <div>
                    <dt>Category</dt>
                    <dd>{template.prize.prizeCategory}</dd>
                  </div>
                  <div>
                    <dt>Prize value</dt>
                    <dd>{formatCurrency(template.prize.prizeValue, money)}</dd>
                  </div>
                  <div>
                    <dt>Ticket price</dt>
                    <dd>{formatCurrency(template.prize.ticketPrice, money)}</dd>
                  </div>
                </dl>
              </div>
              <Link
                className="ci-button"
                data-variant="primary"
                to={{ pathname: '/competitions/listings/new', search: `?template=${template.id}${search ? `&${search.slice(1)}` : ''}` }}
              >
                Use template
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </Card>
  )
}
